import { StackScreenProps } from "@react-navigation/stack";
import React from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { usePromotions } from "@/hooks/domain/promotions";
import { useStoreTypeById } from "@/hooks/domain/storeTypes";
import { useStoresByTypeId } from "@/hooks/domain/stores";
import { HomeNavigation, HomeStackParamList } from "@/navigation/stacks/HomeStack";

import StoresByTypeMobile from "./StoresByType.mobile";
import StoresByTypeWeb from "./StoresByType.web";
import { StoresByTypeScreenProps } from "./types";

type ScreenProps = StackScreenProps<HomeStackParamList, "storesByType">;

const StoresByType = ({ route }: ScreenProps) => {
  const typeId = route?.params?.typeId;

  const { isWebMode } = useViewport();
  const { navigate, setOptions } = useAppNavigation<HomeNavigation>();

  const { data: storeType, isLoading: isLoadingStoreType } = useStoreTypeById(typeId, {
    onSuccess: (data) => {
      setOptions({ title: data?.nome });
    },
  });

  const { data: promotionList, isLoading: isLoadingPromotionList } = usePromotions(typeId, {
    enabled: !!storeType,
  });

  const {
    data: storeList,
    isLoading: isLoadingStoreList,
    hasNextPage,
    fetchNextPage,
  } = useStoresByTypeId(storeType?._id, { enabled: !!storeType });

  const onLoadMoreStores = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const onSelectStore: StoresByTypeScreenProps["onSelectStore"] = (storeId) => {
    navigate("storeHome", { storeId });
  };

  const Screen = isWebMode ? StoresByTypeWeb : StoresByTypeMobile;

  return (
    <Screen
      storeType={storeType}
      promotionList={promotionList}
      isLoadingPromotionList={isLoadingPromotionList || isLoadingStoreType}
      storeList={storeList?.pages?.map((page) => page.docs).flat()}
      isLoadingStoreList={isLoadingStoreList || isLoadingStoreType}
      onLoadMoreStores={onLoadMoreStores}
      onSelectStore={onSelectStore}
    />
  );
};

export default StoresByType;
